import { ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';

import { GetSimpleFooterResponse } from 'services/idm';

import { useBrowsing } from 'hooks/use-browsing';

import { Toast } from 'core/generic/components/general/toast';

import { SimpleHeader } from '../../components/header';
import { SimpleFooter } from '../footer';

type PageTemplateProps = {
	children: ReactNode;
	footerData?: GetSimpleFooterResponse;
	config?: PageTemplateConfig;
};

type PageTemplateConfig = {
	gtmId?: string;
};

export const PageTemplate = ({
	children,
	footerData,
	config,
}: PageTemplateProps) => {
	const { query } = useBrowsing();
	const isFromApp = query.fromapp !== undefined ? true : false;

	return (
		<>
			<Toast />

			{!isFromApp && <SimpleHeader />}

			<Tooltip
				place="top"
				id="tooltip"
				className="tooltip body-xsmall"
				openEvents={{ mouseenter: true, click: true }}
				closeEvents={{ mouseleave: true, click: true }}
				render={({ activeAnchor }) => {
					const title =
						activeAnchor?.getAttribute('data-tooltip-title');
					const description = activeAnchor?.getAttribute(
						'data-tooltip-description'
					);

					if (title || description) {
						return (
							<div className="tooltip__content">
								{title && (
									<div className="tooltip__title bold">
										{title}
									</div>
								)}
								{description && (
									<div className="tooltip__description body-xsmall">
										{description}
									</div>
								)}
							</div>
						);
					}

					return null;
				}}
			/>

			{children}

			{!isFromApp && (
				<>
					{/* TODO: Add isLogoDisplayed from API when ready */}
					<SimpleFooter data={footerData} />
				</>
			)}

			{/* {config?.gtmId && <GoogleTagManager gtmId={config.gtmId} />} */}
		</>
	);
};

export default PageTemplate;
